<script>
export default {
  name: 'SliderCardBasic',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <a
    class="kb-slider-card-basic"
    :class="{ 'full-height-image': !data.title && !data.summary }"
    :href="data.url"
  >
    <div v-if="data.imageUrl" class="kb-slider-card-basic__image">
      <img
        :class="{ 'full-height-image': !data.title && !data.summary }"
        :src="data.imageUrl"
        :alt="data.imageAlt ?? ''"
      />
    </div>

    <p v-if="data.date" class="kb-slider-card-basic__date">{{ data.date }}</p>

    <h3
      v-if="data.title"
      class="kb-slider-card-basic__title"
      :class="{ 'kb-slider-card-basic__title--large': !data.imageUrl }"
    >
      {{ data.title }}
    </h3>

    <p v-if="data.summary" class="kb-slider-card-basic__text">
      {{ data.summary }}
    </p>
  </a>
</template>
